import {Col, Row} from "antd";
import "./styles.scss";
import {under_cons_img} from "../../../../AppImageConst";



const AdminHomePage = () => {

        return (
            <div>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <div style={{display: "flex", justifyContent: 'center', flexDirection: "column", alignItems: 'center'}}>
                            <h1 style={{textAlign: "center", fontSize: 32, color: '#008d86'}}>Welcome to Admin Portal</h1>
                            <img style={{width: 450}} src={under_cons_img} alt=""/>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
;

export default AdminHomePage;
